import { GraphQLClient } from 'graphql-request';
import { gql } from 'urql';
import {
  Mutation,
  Query,
  QueryFirmMembersForFirmArgs,
  QueryFirmMemberEmailNotificationSettingsArgs,
  UpdateFirmMemberInput,
  UpdateFirmMemberEmailNotificationSettingsInput,
} from '../generated/graphql';
import { FirmMemberFragment } from './fragments';

const getFirmMembersQuery = gql`
  ${FirmMemberFragment}
  query FirmMembersForFirm($firmID: ID!, $cursor: String) {
    firmMembersForFirm(firmID: $firmID, cursor: $cursor) {
      items {
        ...FirmMemberFragment
      }
    }
  }
`;

export const clientGetFirmMembersForFirm = async (
  client: GraphQLClient,
  args: QueryFirmMembersForFirmArgs
) => {
  return (
    await client.request<Pick<Query, 'firmMembersForFirm'>>(
      getFirmMembersQuery,
      args
    )
  ).firmMembersForFirm;
};

const updateFirmMemberMutation = gql`
  ${FirmMemberFragment}
  mutation UpdateFirmMember($input: UpdateFirmMemberInput!) {
    updateFirmMember(input: $input) {
      firmMember {
        ...FirmMemberFragment
      }
    }
  }
`;

export const clientUpdateFirmMember = async (
  client: GraphQLClient,
  input: UpdateFirmMemberInput
) => {
  return (
    await client.request<Pick<Mutation, 'updateFirmMember'>>(
      updateFirmMemberMutation,
      { input }
    )
  ).updateFirmMember;
};

const FirmMemberEmailNotificationSettingsFragment = gql`
  fragment FirmMemberEmailNotificationSettingsFragment on FirmMemberEmailNotificationSettings {
    firmMemberID
    changeToken
    newClientMessages
    clientActivity
    newClientsAndProspects
    quarterlyReviewReminders
    clientAccountDeletions
  }
`;

const getFirmMemberEmailNotificationSettingsQuery = gql`
  ${FirmMemberEmailNotificationSettingsFragment}
  query FirmMemberEmailNotificationSettings($firmMemberID: ID!) {
    firmMemberEmailNotificationSettings(firmMemberID: $firmMemberID) {
      ...FirmMemberEmailNotificationSettingsFragment
    }
  }
`;

export const clientGetFirmMemberEmailNotificationSettings = async (
  client: GraphQLClient,
  args: QueryFirmMemberEmailNotificationSettingsArgs
) => {
  return (
    await client.request<
      Pick<Query, 'firmMemberEmailNotificationSettings'>
    >(getFirmMemberEmailNotificationSettingsQuery, args)
  ).firmMemberEmailNotificationSettings;
};

const updateFirmMemberEmailNotificationSettingsMutation = gql`
  ${FirmMemberEmailNotificationSettingsFragment}
  mutation UpdateFirmMemberEmailNotificationSettings(
    $input: UpdateFirmMemberEmailNotificationSettingsInput!
  ) {
    updateFirmMemberEmailNotificationSettings(input: $input) {
      emailNotificationSettings {
        ...FirmMemberEmailNotificationSettingsFragment
      }
    }
  }
`;

export const clientUpdateFirmMemberEmailNotificationSettings = async (
  client: GraphQLClient,
  input: UpdateFirmMemberEmailNotificationSettingsInput
) => {
  return (
    await client.request<
      Pick<Mutation, 'updateFirmMemberEmailNotificationSettings'>
    >(updateFirmMemberEmailNotificationSettingsMutation, { input })
  ).updateFirmMemberEmailNotificationSettings;
};
